module.exports = __webpack_public_path__ + "img/gs.441e0cad.png";